import { NgModule } from '@angular/core';

import { ButtonBasicDirective } from './basic-button.directive';
import { ButtonFilledDirective } from './filled-button.directive';
import { ButtonIconDirective } from './icon-button.directive';
import { ButtonOutlinedDirective } from './outlined-button.directive';

const buttons = [
	ButtonBasicDirective,
	ButtonIconDirective,
	ButtonFilledDirective,
	ButtonOutlinedDirective,
];

@NgModule({
	imports: buttons,
	exports: buttons,
})
export class ButtonsModule {}
